export default "__VITE_ASSET__c56d7f9b__"